import React from 'react';
import { Popover as Popover$1, PopoverTrigger, PopoverContent, PopoverArrow, PopoverCloseButton, PopoverHeader, PopoverBody } from '@chakra-ui/react';
var Popover = function Popover(_ref) {
  var id = _ref.id,
    header = _ref.header,
    description = _ref.description,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === undefined ? 'click' : _ref$trigger,
    _ref$placement = _ref.placement,
    placement = _ref$placement === undefined ? 'auto' : _ref$placement,
    _ref$showArrow = _ref.showArrow,
    showArrow = _ref$showArrow === undefined ? true : _ref$showArrow,
    triggerItem = _ref.triggerItem,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === undefined ? true : _ref$isClosable;
  return /*#__PURE__*/React.createElement(Popover$1, {
    "data-object-type": "popover",
    trigger: trigger,
    id: id,
    placement: placement
  }, /*#__PURE__*/React.createElement(PopoverTrigger, null, triggerItem), /*#__PURE__*/React.createElement(PopoverContent, {
    "data-object-type": "popover-dialog"
  }, !!showArrow && /*#__PURE__*/React.createElement(PopoverArrow, null), !!isClosable && /*#__PURE__*/React.createElement(PopoverCloseButton, {
    "data-object-type": "popover-close-btn"
  }), !!header && /*#__PURE__*/React.createElement(PopoverHeader, null, header), /*#__PURE__*/React.createElement(PopoverBody, null, description)));
};
Popover.displayName = "Popover";
export { Popover };